import {
  Level,
  useSnackNotificationContext,
} from '@sorare/core/src/contexts/snackNotification';
import { formatGqlErrors } from '@sorare/core/src/lib/gql';

import { HANDLED_RULES } from '#src/lib/so5.ts';

export const useHandleComposeTeamErrors = () => {
  const { showNotification } = useSnackNotificationContext();

  const handleErrors = <
    T extends { path: string[] | null; message: string; code: number | null },
  >(
    errors: T[]
  ) => {
    const { unhandledErrors, handledErrors } = errors.reduce<{
      unhandledErrors: T[];
      handledErrors: T[];
    }>(
      (prev, curr) => {
        const ruleHandled = HANDLED_RULES.find(rule => {
          return rule.toLowerCase() === curr.path?.[1].toLowerCase();
        });
        if (ruleHandled) {
          prev.handledErrors.push(curr);
        } else {
          prev.unhandledErrors.push(curr);
        }
        return prev;
      },
      { unhandledErrors: [], handledErrors: [] }
    );

    if (unhandledErrors?.length) {
      showNotification(
        'errors',
        { errors: formatGqlErrors(unhandledErrors) },
        { level: Level.WARN }
      );
    }
    return { unhandledErrors, handledErrors };
  };

  return handleErrors;
};
